// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

export var layout = {
  size0: '0px',
  size1: '4px',
  size2: '8px',
  size3: '12px',
  size4: '16px',
  size5: '20px',
  size6: '24px',
  size7: '28px',
  size8: '32px',
  cornerRadius0: '0px',
  cornerRadius1: '4px',
  cornerRadius2: '8px',
  cornerRadius3: '12px',
  cornerRadius4: '16px',
  xsMax: '575px',
  smMin: '576px',
  smMax: '767px',
  mdMin: '768px',
  mdMax: '991px',
  lgMin: '992px',
  lgMax: '1199px',
  xlMin: '1200px'
};
export var color = {
  hpBlue0: '#e6f0f5',
  hpBlue1: '#ceeffe',
  hpBlue2: '#b7e8fe',
  hpBlue3: '#9fe0fe',
  hpBlue4: '#73cffe',
  hpBlue5: '#3bb7f6',
  hpBlue6: '#0096d6',
  hpBlue7: '#0073a8',
  hpBlue8: '#015985',
  hpBlue9: '#02476b',
  hpBlue10: '#0a3b54',
  hpBlue11: '#0e3245',
  hpBlue12: '#112d3b',
  royalBlue0: '#e9eff7',
  royalBlue1: '#e5eaff',
  royalBlue2: '#d6ddff',
  royalBlue3: '#c3cdff',
  royalBlue4: '#a7b4ff',
  royalBlue5: '#8190ff',
  royalBlue6: '#6374fd',
  royalBlue7: '#4759f5',
  royalBlue8: '#3543c0',
  royalBlue9: '#2c3798',
  royalBlue10: '#28307b',
  royalBlue11: '#262b65',
  royalBlue12: '#22254d',
  cornFlowerBlue0: '#e9eff7',
  cornFlowerBlue1: '#dbebff',
  cornFlowerBlue2: '#c2deff',
  cornFlowerBlue3: '#a6ceff',
  cornFlowerBlue4: '#81baff',
  cornFlowerBlue5: '#549ef7',
  cornFlowerBlue6: '#4483cf',
  cornFlowerBlue7: '#3367a6',
  cornFlowerBlue8: '#294e7c',
  cornFlowerBlue9: '#254266',
  cornFlowerBlue10: '#233854',
  cornFlowerBlue11: '#213046',
  cornFlowerBlue12: '#1f2a3b',
  vividSkyBlue0: '#d7f4f7',
  vividSkyBlue1: '#d4fbff',
  vividSkyBlue2: '#bcf7ff',
  vividSkyBlue3: '#8aefff',
  vividSkyBlue4: '#40defa',
  vividSkyBlue5: '#2ac5e0',
  vividSkyBlue6: '#2796a8',
  vividSkyBlue7: '#187585',
  vividSkyBlue8: '#176673',
  vividSkyBlue9: '#16555f',
  vividSkyBlue10: '#15474f',
  vividSkyBlue11: '#173e45',
  vividSkyBlue12: '#142c30',
  green0: '#d5f5e7',
  green1: '#ccffe8',
  green2: '#a3ffd6',
  green3: '#78ffc2',
  green4: '#4ef5ab',
  green5: '#00d072',
  green6: '#009955',
  green7: '#00834b',
  green8: '#006c3e',
  green9: '#005a35',
  green10: '#034c2e',
  green11: '#07412a',
  green12: '#093021',
  chartreuse0: '#dbf7d0',
  chartreuse1: '#deffd1',
  chartreuse2: '#c3ffab',
  chartreuse3: '#a2ff7d',
  chartreuse4: '#83f955',
  chartreuse5: '#6acc44',
  chartreuse6: '#529e34',
  chartreuse7: '#3f7829',
  chartreuse8: '#366325',
  chartreuse9: '#2e5121',
  chartreuse10: '#28421f',
  chartreuse11: '#24371c',
  chartreuse12: '#202e1a',
  lime0: '#e8f5c4',
  lime1: '#f0ffc7',
  lime2: '#e1ff90',
  lime3: '#d3fb66',
  lime4: '#bce05a',
  lime5: '#a1bf50',
  lime6: '#80993d',
  lime7: '#627332',
  lime8: '#54632d',
  lime9: '#48532a',
  lime10: '#3e4727',
  lime11: '#373d25',
  lime12: '#272b1d',
  mediumOrchid0: '#f2ebf7',
  mediumOrchid1: '#f3e0ff',
  mediumOrchid2: '#edd1ff',
  mediumOrchid3: '#e7c2ff',
  mediumOrchid4: '#d9a3fe',
  mediumOrchid5: '#ca7aff',
  mediumOrchid6: '#b655f5',
  mediumOrchid7: '#8c3ebf',
  mediumOrchid8: '#6f3297',
  mediumOrchid9: '#5b2d7a',
  mediumOrchid10: '#4c2963',
  mediumOrchid11: '#3f2550',
  mediumOrchid12: '#342240',
  lavender0: '#f0eff7',
  lavender1: '#ebe8ff',
  lavender2: '#e4e0ff',
  lavender3: '#d2ccff',
  lavender4: '#c4bdff',
  lavender5: '#a89efa',
  lavender6: '#8880cf',
  lavender7: '#6a62a3',
  lavender8: '#504a78',
  lavender9: '#3f3b5c',
  lavender10: '#36324a',
  lavender11: '#2d2b3d',
  lavender12: '#292735',
  hotPink0: '#f7ebf1',
  hotPink1: '#ffe3f3',
  hotPink2: '#ffd1eb',
  hotPink3: '#ffbae1',
  hotPink4: '#ff8ece',
  hotPink5: '#ff63bb',
  hotPink6: '#d94e9c',
  hotPink7: '#a8417b',
  hotPink8: '#7f345f',
  hotPink9: '#672f4f',
  hotPink10: '#542a42',
  hotPink11: '#452638',
  hotPink12: '#38232f',
  fuchsia0: '#f7eaf7',
  fuchsia1: '#ffe3ff',
  fuchsia2: '#ffd1ff',
  fuchsia3: '#ffb5ff',
  fuchsia4: '#ff84ff',
  fuchsia5: '#e070e0',
  fuchsia6: '#bf62bf',
  fuchsia7: '#964e96',
  fuchsia8: '#733e73',
  fuchsia9: '#5c355c',
  fuchsia10: '#4a2e4a',
  fuchsia11: '#3d283d',
  fuchsia12: '#332433',
  salmon0: '#f7eeed',
  salmon1: '#ffe8e5',
  salmon2: '#ffdedb',
  salmon3: '#ffccc7',
  salmon4: '#ffb4ad',
  salmon5: '#ff948a',
  salmon6: '#de7066',
  salmon7: '#a15850',
  salmon8: '#754844',
  salmon9: '#5c3b37',
  salmon10: '#4d312e',
  salmon11: '#402b29',
  salmon12: '#362625',
  darkOrange0: '#fcebdc',
  darkOrange1: '#ffdbb2',
  darkOrange2: '#ffc98c',
  darkOrange3: '#ffb866',
  darkOrange4: '#ffa238',
  darkOrange5: '#ff8900',
  darkOrange6: '#e07200',
  darkOrange7: '#b2600c',
  darkOrange8: '#874e14',
  darkOrange9: '#6e4318',
  darkOrange10: '#5c3a19',
  darkOrange11: '#4a3016',
  darkOrange12: '#382514',
  tangerine0: '#f7edda',
  tangerine1: '#ffe7b8',
  tangerine2: '#ffdb94',
  tangerine3: '#ffcc69',
  tangerine4: '#ffbd3b',
  tangerine5: '#e09600',
  tangerine6: '#b27d12',
  tangerine7: '#8f6c24',
  tangerine8: '#735822',
  tangerine9: '#5c4821',
  tangerine10: '#4f3e20',
  tangerine11: '#42341b',
  tangerine12: '#332916',
  gold0: '#f7f2cb',
  gold1: '#fff29e',
  gold2: '#ffe970',
  gold3: '#ffe137',
  gold4: '#f9d300',
  gold5: '#e5c300',
  gold6: '#bc9f00',
  gold7: '#877300',
  gold8: '#736100',
  gold9: '#5c4e00',
  gold10: '#544700',
  gold11: '#413700',
  gold12: '#302900',
  bronze0: '#f7f0e3',
  bronze1: '#ffeac7',
  bronze2: '#fae1b6',
  bronze3: '#f0d19e',
  bronze4: '#e5bf7e',
  bronze5: '#d6ab63',
  bronze6: '#b0873f',
  bronze7: '#856630',
  bronze8: '#664e26',
  bronze9: '#52401f',
  bronze10: '#42341a',
  bronze11: '#3b2f1a',
  bronze12: '#302717',
  maroon0: '#f7ebee',
  maroon1: '#ffe3eb',
  maroon2: '#ffd1e0',
  maroon3: '#febacf',
  maroon4: '#fe93b5',
  maroon5: '#fa6996',
  maroon6: '#e54577',
  maroon7: '#c22757',
  maroon8: '#9b1741',
  maroon9: '#851538',
  maroon10: '#69132e',
  maroon11: '#571027',
  maroon12: '#4b0f22',
  hunterGreen0: '#e0f5df',
  hunterGreen1: '#d6ffd4',
  hunterGreen2: '#aaffa3',
  hunterGreen3: '#8bf684',
  hunterGreen4: '#5ee854',
  hunterGreen5: '#43cc39',
  hunterGreen6: '#29a321',
  hunterGreen7: '#087a00',
  hunterGreen8: '#116108',
  hunterGreen9: '#0b4f06',
  hunterGreen10: '#0c4208',
  hunterGreen11: '#0b3608',
  hunterGreen12: '#0a2b08',
  darkNavy0: '#ededf7',
  darkNavy1: '#e5e5ff',
  darkNavy2: '#dbddff',
  darkNavy3: '#ced0fd',
  darkNavy4: '#bbbdfb',
  darkNavy5: '#a2a5fb',
  darkNavy6: '#7c80f4',
  darkNavy7: '#4d52e5',
  darkNavy8: '#3e41b8',
  darkNavy9: '#2d2f86',
  darkNavy10: '#272968',
  darkNavy11: '#212250',
  darkNavy12: '#212248',
  warmGray0: '#f2f0f1',
  warmGray1: '#ede8ea',
  warmGray2: '#ebe1e4',
  warmGray3: '#ded3d6',
  warmGray4: '#cfbfc3',
  warmGray5: '#bca9ae',
  warmGray6: '#9c868c',
  warmGray7: '#7d686e',
  warmGray8: '#5c4d50',
  warmGray9: '#483c3f',
  warmGray10: '#3a3133',
  warmGray11: '#2e2829',
  warmGray12: '#231f20',
  red0: '#faeceb',
  red1: '#ffdbd9',
  red2: '#ffc1bd',
  red3: '#ffa59e',
  red4: '#ff8373',
  red5: '#ff6445',
  red6: '#ff3900',
  red7: '#cc2c00',
  red8: '#9f2301',
  red9: '#802208',
  red10: '#68240f',
  red11: '#522112',
  red12: '#422016',
  gray0: '#fafafa',
  gray1: '#f1f1f1',
  gray2: '#e8e8e8',
  gray3: '#d9d9d9',
  gray4: '#c2c2c2',
  gray5: '#a3a3a3',
  gray6: '#7d7d7d',
  gray7: '#666666',
  gray8: '#545454',
  gray9: '#404040',
  gray10: '#333333',
  gray11: '#292929',
  gray12: '#212121',
  black: '#000',
  white: '#fff',
  highContrastYellow: '#FFF700',
  highContrastBlue: '#00D3FF',
  highContrastPink: '#FE6AFF',
  highContrastGray: '#ADADAD',
  highContrastEigengrau: '#16141D'
};
export var typography = {
  family0: "'Forma DJR UI', Arial, sans-serif",
  family1: "'Forma DJR UI Italic', Arial, sans-serif",
  size0: '12px',
  size1: '14px',
  size2: '16px',
  size3: '18px',
  size4: '20px',
  size5: '24px',
  size6: '28px',
  size7: '32px',
  size8: '36px',
  size9: '40px',
  size10: '56px',
  size11: '72px',
  lineHeight0: '12px',
  lineHeight1: '16px',
  lineHeight2: '20px',
  lineHeight3: '24px',
  lineHeight4: '28px',
  lineHeight5: '32px',
  lineHeight6: '36px',
  lineHeight7: '40px',
  lineHeight8: '44px',
  lineHeight9: '48px',
  lineHeight10: '64px',
  lineHeight11: '84px'
};
var tokens = {
  layout: layout,
  color: color,
  typography: typography
};
export default tokens;